import styled from "styled-components";
import { Grid } from "../../components/layout";

import { Permission } from "../../components/permission";
import { AMLMasteryCourse } from "./tiles/aml";
import { useBrowserWallet } from "../../store/wallets/crypto";

const StyledGrid = styled(Grid)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

export const ELearningCouponsPage = () => {

    const {
        // connect,
        // verify,
        // state,
        balance,
        // accounts,
        // isVerified,
    } = useBrowserWallet();

    // const balanceValue = useMemo(
    //     () =>
    //       balance.fold(
    //         () => null,
    //         ({ symbol, amount }) => (
    //             {formatEther(amount)} {symbol}
    //         )
    //       ),
    //     [balance]
    //   );

    return (
        <>
            <Permission
                roles={["ROLE_USER"]}
                alternative={
                    <>
                        {/* <StyledGrid col-lg={3} col-xs={1} col-sm={2}>
                    <Grid col-xs={2}>
                        <AMLMasteryCourse />
                    </Grid>
                </StyledGrid> */}
                    </>
                }
            >
                <StyledGrid col-lg={3} col-xs={1} col-sm={2}>
                    <Grid col-xs={2}>
                        <AMLMasteryCourse />
                    </Grid>
                </StyledGrid>
            </Permission>
        </>
    );
};
